import { render } from "./addProject.vue?vue&type=template&id=70f118d7"
import script from "./addProject.vue?vue&type=script&lang=js"
export * from "./addProject.vue?vue&type=script&lang=js"

import exportComponent from "F:\\颖\\小荔园\\素材库\\sucaiku(3)(1)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__